<template>
    <div>
        <canvas ref="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
    </div>
</template>
<script>
import { Const } from "@/model/ApiModel";
import logger from "@/assets/log";
import config from "@/config";

const log = logger("components:watermarkpreview");

const STANDARD_WIDTH = 1280;
const STANDARD_HEIGHT = 720;
const STANDARD_RATIO = STANDARD_WIDTH / STANDARD_HEIGHT;
const MARGIN_X_RATIO = 0.043;
const MARGIN_Y_RATIO = 0.0375;

const scaleCanvas = document.createElement("canvas");
const scaleCtx = scaleCanvas.getContext("2d");

export default {
    props: ["model", "fontList"],
    watch: {
        model: {
            handler(val) {
                var oldVal = this.oldModel;
                if (
                    val.fontSize != oldVal.fontSize ||
                    val.fontColor != oldVal.fontColor ||
                    val.fontFamily != oldVal.fontFamily ||
                    val.watermarkType != oldVal.watermarkType ||
                    val.words != oldVal.words ||
                    val.imagePath != oldVal.imagePath
                ) {
                    this.refresh();
                }
                if (val.fontFamily != oldVal.fontFamily) {
                    this.refresh(false, true);
                }
                if (
                    val.opacity != oldVal.opacity ||
                    val.position != oldVal.position ||
                    val.zoomPercent != oldVal.zoomPercent
                ) {
                    this.refresh(true);
                }
                this.oldModel = { ...val };
            },
            deep: true
        }
    },
    data() {
        return {
            canvasWidth: null,
            canvasHeight: null,
            imageCache: new Image(),
            originWidth: 0,
            originHeight: 0,
            oldModel: { ...this.model }
        };
    },
    methods: {
        async refresh(useCache/* , isFontFamily */) {
            let imageZoom = 1;
            let src;
            if(this.model.imagePath){
                src = this.model.imagePath;
            }else {
                src = this.model.uploadServerUrl + this.model.uploadPath
            }

            if (this.model.watermarkType == Const.Watermark.Type.Text) {
                if (!useCache) {
                    // if(isFontFamily){
                    //     var fontName = await helper.getFontName(
                    //         this.model.fontFamily
                    //     );
                    // }
                    let font = this.fontList && this.fontList.find(font=>font.fontFamily == this.model.fontFamily);
                    let fontName = font ? font.name : "黑体";

                    src = this.createTextImage(
                        this.model.words || '',
                        this.model.fontSize,
                        this.model.fontColor,
                        fontName
                        // this.model.fontFamily.name
                    );
                }
            } else {
            	if (this.model.zoomPercent) {
                    imageZoom = this.model.zoomPercent / 50;
                }
            }

            if (!useCache && src) {
                // 加载并缩放图片、限制预览图片的大小，优化性能
                try {
	                await this.loadAndScaleImage(this.imageCache, src, 600);
                } catch(e) {
                	this.imageCache = new Image();
                	log.error(e);
                }
            }

            let scale = this.canvasWidth / STANDARD_WIDTH;

            this.drawImage(
                this.$refs.canvas.getContext("2d"),
                this.imageCache,
                this.originWidth,
                this.originHeight,
                this.model.opacity,
                imageZoom,
                this.model.position,
                scale
            );
        },
        createTextImage(text, fontsize, fontcolor, family) {
            var canvas = scaleCanvas;
            var context = scaleCtx;
            var textList = text.split(/\r?\n/g); //存放切割后的内容
            family = config.FontMap[family] || family || "黑体"; // family 必须有，否则无法设置ctx.font

            var width = 0;
            context.font = fontsize + "px " + family;
            for (var b = 0; b < textList.length; b++) {
                width = Math.max(width, context.measureText(textList[b]).width);
            }

            canvas.width = width;
            if (textList.length == 1) {
                canvas.height = textList.length * +fontsize;
            } else {
                canvas.height = textList.length * (+fontsize + fontsize / 2);
            }

            context.fillStyle = fontcolor;
            context.font = fontsize + "px " + family;
            //top（顶部对齐） hanging（悬挂） middle（中间对齐） bottom（底部对齐） alphabetic是默认值
            context.textBaseline = "top";

            // eslint-disable-next-line no-redeclare
            for (var b = 0; b < textList.length; b++) {
                context.fillText(
                    textList[b],
                    0,
                    b * (+fontsize + fontsize / 2)
                );
            }

            log(
                `createTextImage:t=${text},w=${canvas.width},h=${canvas.height}`
            );

	        return canvas.toDataURL("image/png"); //注意这里背景透明的话，需要使用png
        },
        async loadAndScaleImage(image, src, maxSize) {
            return new Promise((resolve, reject) => {
                image.crossOrigin = "Anonymous";
                image.onload = () => {
                    this.originWidth = image.width;
                    this.originHeight = image.height;

                    if (image.width > maxSize || image.height > maxSize) {
                        let scaledSrc = this.scaleImage(image, maxSize);
                        image.onload = resolve;
                        image.src = scaledSrc;
                    } else {
                        resolve();
                    }
                };
                image.onerror = reject;
                image.src = src;
            });
        },
        scaleImage(image, maxSize) {
            if (image.width > maxSize || image.height > maxSize) {
                log(`scaleImage`);

                let newW = maxSize;
                let newH = maxSize;

                if (image.width > image.height) {
                    newH = (maxSize / image.width) * image.height;
                } else {
                    newW = (maxSize / image.height) * image.width;
                }

                scaleCanvas.width = newW;
                scaleCanvas.height = newH;
                scaleCtx.drawImage(
                    image,
                    0,
                    0,
                    image.width,
                    image.height,
                    0,
                    0,
                    newW,
                    newH
                );
                
				try {
                	return scaleCanvas.toDataURL("image/png");
				} catch(e) {
					log.error(e);
					return "";
				}
            }
            return image.src;
        },
        drawImage(
            ctx,
            image,
            imgWidth,
            imgHeight,
            opacity,
            imageZoom,
            position,
            scale
        ) {

            var canvasWidth = ctx.canvas.width;
            var canvasHeight = ctx.canvas.height;

            var marginX = canvasWidth * MARGIN_X_RATIO;
            var marginY = canvasHeight * MARGIN_Y_RATIO;
            var Position = Const.Watermark.Position;

            imgWidth *= imageZoom;
            imgHeight *= imageZoom;

            marginX *= scale;
            marginY *= scale;
            imgWidth *= scale;
            imgHeight *= scale;

            ctx.clearRect(0, 0, canvasWidth, canvasHeight); //清空画布
            ctx.globalAlpha = opacity;

            switch (position) {
                case Position.LeftTop:
                    ctx.drawImage(image, marginX, marginY, imgWidth, imgHeight);
                    break;
                case Position.LeftBottom:
                    ctx.drawImage(
                        image,
                        marginX,
                        canvasHeight - (imgHeight + marginY),
                        imgWidth,
                        imgHeight
                    );
                    break;
                case Position.RightTop:
                    ctx.drawImage(
                        image,
                        canvasWidth - (imgWidth + marginX),
                        marginY,
                        imgWidth,
                        imgHeight
                    );
                    break;
                case Position.RightBottom:
                    ctx.drawImage(
                        image,
                        canvasWidth - (imgWidth + marginX),
                        canvasHeight - (imgHeight + marginY),
                        imgWidth,
                        imgHeight
                    );
                    break;
                case Position.Center:
                    ctx.drawImage(
                        image,
                        (canvasWidth - imgWidth) / 2,
                        (canvasHeight - imgHeight) / 2,
                        imgWidth,
                        imgHeight
                    );
                    break;
                case Position.Repeat:
                    var watermarkW = imgWidth;
                    var watermarkH = imgHeight;
                    var margin = watermarkH / 2;
                    var offsetX = -watermarkW + (canvasWidth % watermarkW) / 2;

                    if(watermarkW <= 0 || watermarkH <= 0) {
                        break;
                    }

                    var yEven = false;
                    for (
                        var y = 0;
                        y < canvasHeight;
                        y += watermarkH + margin
                    ) {
                        var xEven = false;
                        for (
                            var x = offsetX;
                            x < canvasWidth;
                            x += watermarkW
                        ) {
                            if (yEven == xEven) {
                                ctx.drawImage(
                                    image,
                                    x,
                                    y,
                                    watermarkW,
                                    watermarkH
                                );
                            }
                            xEven = !xEven;
                        }
                        yEven = !yEven;
                    }
                    break;
            }
            
            log(`drawImage:z=${imageZoom},w=${imgWidth},h=${imgHeight}`);
        }
    },
    mounted() {
        let canvas = this.$refs.canvas;
        this.canvasWidth = canvas.offsetWidth;
        this.canvasHeight = this.canvasWidth / STANDARD_RATIO;
        canvas.width = this.canvasWidth;
        canvas.height = this.canvasHeight;
        // 解决无法缩放跨域图片的问题
        this.imageCache.setAttribute("crossOrigin", "Anonymous");
        this.refresh(false, true);
    }
};
</script>
<style lang="less" scoped>
canvas {
    width: 100%;
    height: 100%;
    display: block;
}
</style>